import { render, staticRenderFns } from "./DashboardProjectCount.vue?vue&type=template&id=3dffd9cc&scoped=true"
import script from "./DashboardProjectCount.vue?vue&type=script&lang=js"
export * from "./DashboardProjectCount.vue?vue&type=script&lang=js"
import style0 from "./DashboardProjectCount.vue?vue&type=style&index=0&id=3dffd9cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dffd9cc",
  null
  
)

export default component.exports